import React, { useEffect, useRef } from 'react';

const HilltopBanner = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    let timeoutId;
    
    // Check if script already exists to prevent redundant calls
    if (container.querySelector('script')) return;

    timeoutId = setTimeout(() => {
      try {
        const s = document.createElement('script');
        const aqicw = {};
        s.settings = aqicw || {};
        s.src = "https://untimely-hello.com/bWXfVisQd.GHlW0/YEWicN/aeFme9Pu_ZlU/l/kFPOTUY/3HN/z_Mp1/N/DKEGtqNejOcn3/MqzmUy0GNdQu";
        s.async = true;
        s.referrerPolicy = 'no-referrer-when-downgrade';

        s.onerror = (e) => {
          console.warn('HilltopBanner script failed to load:', e);
        };

        container.appendChild(s);
      } catch (err) {
        console.error('Error injecting HilltopBanner script:', err);
      }
    }, 100); // Small delay to avoid race conditions

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return <div ref={containerRef} className="hilltop-banner-container" />;
};

export default HilltopBanner;